"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TYPES = tslib_1.__importStar(require("./action-types"));
/*******************************************************************************
 *  3. Fetch actionCreators
 *
 * each individal Fetch call within an Dux or Reducers file
 * is respondible for including the follwing actionCreators, so that
 * fetching, fetched and fetchingError objects get updated correctly within the app state tree
 * check app state tree object in the logger to see how each object gets updated
 */
/*
 * our fetching actionCreator is executed before the Fetch function is executed, typically.
 * our fetching object determines when the app shows fetching spinners or fetching dots.
 * the reducers listening for DATA_FETCHING also sets fetched to false
 */
exports.fetching = function (type) {
    return {
        type: TYPES.FETCHING,
        fetching: type
    };
};
/*
 * our fetched actionCreator runs when we receive a success back from the Fetched service.
 * the reducers listening for DATA_FETCHED also sets fetching to false
 * the fetched object in state tree is used to short circuit a component that shouldn't
 * render until the data is available. the fetched actionCreator should be executed after we
 * dispatch the fetched data to the corresponding reducers
 */
exports.fetched = function (type) {
    return {
        type: TYPES.FETCHED,
        fetched: type
    };
};
/*
 * our FetchingError actionCreator runs when we receive a success of false from the service or
 * when the Fetch function iteself fails due to a syntax error, etc.
 * the reducer listend for DATA_FETCHING_ERROR also sets fetching and fetched to false for the corresponding type
 */
exports.fetchingError = function (type, error, results) {
    if (results === void 0) { results = null; }
    return {
        type: TYPES.FETCHING_ERROR,
        fetchingError: type,
        message: error,
        results: results
    };
};
/*
 * another helper function to set a key in fetched to false, after it has already been fetched.
 * mostly used when unmounting some components
 */
exports.resetFetched = function (type) {
    return {
        type: TYPES.RESET_FETCHED,
        fetched: type
    };
};
/*
 * remove a fetchingError
 */
exports.removeFetchingError = function (type) {
    return {
        type: TYPES.REMOVE_FETCHING_ERROR,
        fetchingError: type
    };
};
//# sourceMappingURL=actions.js.map